import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'truncate'
})
export class TruncatePipe implements PipeTransform {

  transform(value: string, maxLength: number): string {
    // If the value is null/undefined or its length is within the limit, return it as is.
    if (!value || value.length <= maxLength) {
      return value;
    }
    // Truncate the value and append "..."
    return value.substring(0, maxLength) + '...';
  }

}
